/**
 * errorMappingMiddleware — normalise + log every command failure, once.
 *
 * Only failures are logged: a successful dispatch passes through silently, so
 * anything reaching the console is a real error.
 */

import type { CommandMiddleware } from 'src/content/ChatV2/commands/ICommand';
import { parseHttpError } from 'src/content/ChatV2/lib/errors';
import logger from 'src/utils/logger';

export const errorMappingMiddleware: CommandMiddleware = {
  name: 'error-mapping',
  async intercept(invocation, next) {
    try {
      return await next();
    } catch (error) {
      const chatError = parseHttpError(error);
      logger.error('[chat] command failed', {
        command: invocation.command.name,
        chatId: invocation.context.chatId,
        correlationId: invocation.context.correlationId,
        code: chatError.code,
        origin: chatError.origin,
        details: chatError.details,
        error
      });
      throw error;
    }
  }
};
